import 'firebaseui/dist/firebaseui.css';

import { getAuth, FacebookAuthProvider, signInWithRedirect, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, linkWithRedirect  } from "firebase/auth";
import { addDoc, collection, getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './constants';
import {  } from "firebase/auth";


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const auth = getAuth();

interface NetworkInformation extends Navigator {
  connection: {
    effectiveType: string;
    saveData: boolean;
  };
}

export async function SignInWithGoogle() {

  try{
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    await signInWithRedirect(auth, provider);
  }catch(error){
    sendLoginErrors(error);
  }
  
}


export async function SignInWithGooglePopup() {

  try{
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      const userCred = await signInWithPopup(auth, provider);
      return userCred;
  }catch(error){
      sendLoginErrors(error);
  }
}

export async function SignInWithFacebook() {
  try{

    const provider = new FacebookAuthProvider();
    if (auth.currentUser) { // If the user is signed in
      await linkWithRedirect(auth.currentUser, provider); // Link the Facebook account
    } else {
      await signInWithRedirect(auth, provider); // If the user is not signed in, sign in with Facebook
      
    }
  }catch(error){
    sendLoginErrors(error);
  }
}

export async function sendLoginErrors(error:any, email?:string) {
  addDoc(collection(db, "login_errors"), {
    error: JSON.stringify(error),
    timestamp: new Date().toISOString(),
    browserInfoAndState: await browserInfoAndState(),
    
    
  }).catch((error) => {
    return error.message;
  });
  
  
}


export async function browserInfoAndState() {
  // Detect browser type
  let browserType = 'Not known';
  if (window.navigator.userAgent.indexOf('Chrome') !== -1) { browserType = 'Google Chrome'; }
  else if (window.navigator.userAgent.indexOf('Firefox') !== -1) { browserType = 'Mozilla Firefox'; }
  else if (window.navigator.userAgent.indexOf('MSIE') !== -1) { browserType = 'Internet Explorer'; }
  else if (window.navigator.userAgent.indexOf('Edge') !== -1) { browserType = 'Edge'; }
  else if (window.navigator.userAgent.indexOf('Safari') !== -1) { browserType = 'Safari'; }
  else if (window.navigator.userAgent.indexOf('Opera') !== -1) { browserType = 'Opera'; }
  else { browserType = 'Others'; }

  // Check if cookies are enabled
  const cookiesEnabled = navigator.cookieEnabled;

  // Check if JavaScript is enabled
  const javaScriptEnabled = typeof window !== 'undefined';

  // Detect browser language
  const browserLanguage = navigator.language;

  // Check if the browser supports service workers (required for PWAs)
  const pwaSupported = 'serviceWorker' in navigator;

  // Get user agent
  const userAgent = navigator.userAgent;
  //console.log("USER AGENT",userAgent);
  /*
  if (useragent.includes("; wv")) {
    useragent = useragent.replace("; wv", ")");
  }
  */
  // Get screen resolution
  const screenResolution = `${window.screen.width}x${window.screen.height}`;

  // Get browser viewport size
  const viewportSize = `${window.innerWidth}x${window.innerHeight}`;

  // Check if sessionStorage is accessible
  let sessionStorageAccessible = false;
  try {
    sessionStorage.setItem('test', 'test');
    sessionStorage.removeItem('test');
    sessionStorageAccessible = true;
  } catch(e) {
    sessionStorageAccessible = false;
  }

  // Get network information
  let networkInfo = {};
  const navigatorWithNetwork = navigator as NetworkInformation;
  if (navigatorWithNetwork.connection) {
    networkInfo = {
      effectiveType: navigatorWithNetwork.connection.effectiveType,
      saveData: navigatorWithNetwork.connection.saveData,
    };
  }
  

  // Log all this information to Firebase
  const logData = {
    browserType,
    cookiesEnabled,
    javaScriptEnabled,
    browserLanguage,
    pwaSupported,
    userAgent,
    screenResolution,
    viewportSize,
    sessionStorageAccessible,
    networkInfo
    
  };
  return logData;
}


export const SignInWithEmailPass = async (email:string, password:string) => {
  try {
    const auth = getAuth();
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential;
  } catch (error) {
    sendLoginErrors(error);
  }
};




export const isInAppBrowser = () => {
  const ua = window.navigator.userAgent;

  if (ua.includes(" wv")) {
    return true;
  }

  // List of known patterns found in the user agents of in-app browsers
  const patterns = [
    "FBAV", // Facebook App for iOS and Android
    "FBAN", // Facebook App for Android
    "Instagram", // Instagram
    "Twitter", // Twitter
    "Line", // Line
    "Snapchat", // Snapchat
    "Pinterest" // Pinterest
  ];

  // Check if any of the known patterns exist in the user agent
  const isInApp = patterns.some(pattern => ua.includes(pattern));

  return isInApp;
};
